<template>
  <div class="title">
    <h3 class="first-title">
      <span>{{ firstChar }}</span>{{ otherChar }}
    </h3>
    <h4 v-if="subTitle" class="sub-title">
      {{ subTitle }}
    </h4>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    upperTitle() {
      return this.title.toUpperCase()
    },
    firstChar() {
      return this.upperTitle.slice(0, 1)
    },
    otherChar() {
      return this.upperTitle.slice(1)
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  text-align: left;
  margin-bottom: 32px;
  @include minWidth992 {
    text-align: center;
  }
}
.first-title {
  color: $black;
  font-weight: 500;
  font-size: 28px;
  span {
    font-size: 36px;
    color: $mainPurple;
  }
  @include minWidth992 {
    font-size: 32px;
    span {
      font-size: 48px;
    }
  }
}
.sub-title {
  font-weight: 400;
  color: $lightGrey;
  position: relative;
  display: inline;
  left: 40px;
  font-size: 16px;

  &:before, &:after {
    content: '';
    display: inline-block;
    height: 2px;
    width: 20px;
    background-color: $lightGrey;
    position: absolute;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  &:before {
    left: -20px;
  }
  &:after {
    right: -36px;
  }

  @include minWidth992 {
    font-size: 24px;
    left: 0px
  }
}
</style>
